<template>
  <div>
    <Post :post="post"/>
  </div>
</template>

<script setup>
import {useRoute} from 'vue-router';

const route = useRoute();

const postId = route.params.id;
const username = route.params.username;

const post = ref(null);
fetchPost(postId).then((data) => {
  post.value = data;
});
</script>
